import { type RxCollection, type RxCollectionCreator } from 'rxdb';
import { AppointmentProposal } from '../../../data-access/appointmentProposals';
import {
  identityMigration,
  lwwConflictHandler,
} from '../../rxdb/utils/collectionDefaults';

const proposalsSchema = {
  version: 4,
  primaryKey: 'appointmentProposalId',
  type: 'object',
  properties: {
    jobId: { type: 'string', maxLength: 36 },
    appointmentId: { type: 'string', maxLength: 36 },
    appointmentProposalId: { type: 'string', maxLength: 36 },
    entityType: { type: 'string' },
    expiryDate: { type: 'string' },
    customerExperience: { type: 'object' },
    outageExperience: { type: 'object' },
    surveyContacts: { type: 'array' },
    selectedUpgradeIds: { type: 'array' },
    mediaChecklist: { type: 'object' },
    notes: { type: 'string' },
    status: { type: 'string' },
    surveyType: { type: 'string' },
    presentationConfig: { type: 'object' },
    proposalType: { type: 'string' },
    installationType: { type: 'string' },
    downPayment: { type: 'object' },
    timeZone: { type: 'string' },
    syncedAt: {
      type: 'number',
      multipleOf: 1,
      maximum: 9999999999999,
      minimum: 0,
    },
    updatedAt: { type: 'string' },
    createdAt: { type: 'string' },
    offlineSyncErrors: { type: ['object', 'null'] },
  },
  indexes: [['appointmentId'], ['syncedAt']],
  required: ['appointmentId', 'appointmentProposalId', 'syncedAt'],
} as const;

export const proposalsCollections: Record<
  'appointment_proposals',
  RxCollectionCreator
> = {
  appointment_proposals: {
    autoMigrate: false,
    schema: proposalsSchema,
    conflictHandler: lwwConflictHandler,
    migrationStrategies: {
      1: identityMigration,
      2: identityMigration,
      3: identityMigration,
      4: identityMigration,
    },
  },
};

export type AppointmentProposalDocType = AppointmentProposal & {
  syncedAt: number;
};

export type AppointmentProposalsCollections = {
  appointment_proposals: RxCollection<AppointmentProposalDocType>;
};
